export enum LocalStorageKeys {
    AUTHENTICATION = 'authentication',
    EMAIL_RESET_PASSWORD = "email_reset_password",
    TOKEN_RESET_PASSWORD = "token_reset_password",
    TIMER_MAP = "timer_map",
    DRAFT_ARTICLE = "draft_article",
    EDITED_DRAFT_ARTICLE = "edited_draft_article",
    ARTICLE_DRAFT_ALL_FILES = "article_draft_all_files",
    ARTICLE_DRAFT_USED_FILES = "article_draft_used_files",
    ARTICLE_ALL_FILES = "article_all_files",
    ARTICLE_USED_FILES = "article_used_files",
}
